module.exports = __webpack_public_path__ + "assets/img/bedroom_9.c2724b95.jpg";